import type { BiTrackParams } from '../types';

export const BiTrackApi = Symbol('BiTrackApi');

export interface BiTrackApi {
  biTrack(dataTrack: BiTrackParams): Promise<boolean>;
}
